var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',{staticClass:"load-progress-bar-container alert alert-info hidden-print",attrs:{"role":"status","aria-live":"polite"}},[_c('i',{staticClass:"loading-indicator glyphicon glyphicon-refresh",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.loadMsg))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }